<template>
  <div id="leaderDetails">
    <div class="data">
      <el-page-header
        :title="$t('common.goBack')"
        :content="null"
        class="mainCard"
        @back="$router.go(-1)"
      />

      <el-card
        v-loading="loading"
        class="leaderCard mainCard clear-card"
        shadow="hover"
      >
        <div v-if="leader">
          <div
            class="row1"
          >
            <div class="left">
              <div class="name">
                {{ leader.full_name }}
              </div>
              <div class="email">
                <a
                  :href="`mailto:${leader.email}`"
                  target="_blank"
                  class="emailLink"
                >
                  {{ leader.email }}
                </a>
              </div>
            </div>
            <el-button
              v-if="editMode === false"
              round
              class="clearBtn"
              @click="editMode = true"
            >
              {{ $t('common.edit') }} <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              v-if="editMode === true"
              round
              class="saveBtn"
              @click="editMode = false"
            >
              {{ $t('common.close') }}
            </el-button>
          </div>

          <el-row
            type="flex"
            class="row2"
          >
            <el-col
              :span="responsiveCol.big"
              class="col1"
            >
              <div class="label">
                {{ $t('coach.coach') }}
              </div>
              <div class="coach">
                {{ leader.selected_coach ? leader.selected_coach : '-' }}
              </div>
            </el-col>
            <el-col
              :span="responsiveCol.big"
              class="col2"
            >
              <div class="label">
                {{ $t('common.lgaLongSingle') }}
              </div>
              <div
                v-if="leader.lga && (leader.lga.lga1 || leader.lga.lga2)"
                class="lga"
              >
                <div
                  v-if="leader.lga.lga1"
                  class="lgaItem"
                >
                  <span class="lgaNumber">1.</span>
                  <span>{{ leader.lga.lga1 }}</span>
                </div>

                <div
                  v-if="leader.lga.lga2"
                  class="lgaItem"
                >
                  <span class="lgaNumber">2.</span>
                  <span>{{ leader.lga.lga2 }}</span>
                </div>
              </div>
              <div
                v-else
                class="lga"
              >
                -
              </div>
            </el-col>
            <el-col
              :span="responsiveCol.small"
              class="col3"
            >
              <div class="label">
                {{ $t('session.sessionCap') }}
              </div>
              <div class="lga">
                {{ leader.session_id | formatSession }}
              </div>
            </el-col>
            <!--<el-col
              :span="responsiveCol.big"
              class="col2"
            >
              <div class="label">
                Line Manager
              </div>
              <div class="manager">
                {{ lineManagers }}
              </div>
            </el-col>-->
            <el-col
              :span="responsiveCol.big"
              class="col1"
            >
              <div class="label">
                {{ $t('common.team') }}
              </div>
              <el-select
                v-if="editMode"
                v-model="leader.organization.uuid"
                :placeholder="$t('common.select')"
                @change="updateTeam"
              >
                <el-option
                  v-for="(team, key) in teams"
                  :key="key"
                  :label="team.name"
                  :value="team.uuid"
                />
              </el-select>
              <div v-else>
                {{ currentTeam }}
              </div>
            </el-col>
            <el-col
              :span="responsiveCol.big"
              class="col2"
            >
              <div class="label">
                {{ $t('oa.leader.status') }}
              </div>
              <el-radio-group
                v-if="editMode"
                v-model="leader.is_active"
                :placeholder="$t('common.select')"
                @change="updateAvailability"
              >
                <el-radio
                  v-for="(option, key) in availabilityOptions"
                  :key="key"
                  :label="option.value"
                >
                  {{ option.label }}
                </el-radio>
              </el-radio-group>
              <div v-else>
                {{ leader.is_active ? $t('oa.leader.active') : $t('oa.leader.deactivated') }}
              </div>
            </el-col>
            <el-col
              :span="responsiveCol.small"
              class="col2"
            >
              <div class="label">
                {{ $t('oa.leader.cvcReview') }}
              </div>
              <div>
                <el-button
                  type="default"
                  class="reportBtn"
                  round
                  @click="showCvc = true"
                >
                  {{ $t('common.viewReport') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>

        <div v-else>
          {{ $t('oa.leader.noDetailData') }}
        </div>
      </el-card>

      <el-table
        v-if="leader"
        v-loading="loading"
        :data="sortedStakeholders"
        style="width: 100%;"
        class="supporterList clear-table mainCard"
        :empty-text="$t('common.noData')"
      >
        <el-table-column
          :label="$t('oa.leader.coworkerName')"
          :min-width="160"
        >
          <template
            slot-scope="scope"
          >
            {{ scope.row.first_name }} {{ scope.row.last_name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="email"
          :label="$t('common.email')"
          :min-width="120"
        >
          <template slot-scope="emailScope">
            <a
              :href="`mailto:${emailScope.row.email}`"
              class="emailLink"
            >
              {{ emailScope.row.email }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('oa.leader.relationship')"
          :min-width="120"
        >
          <template
            slot-scope="scope"
          >
            {{ $t(`stakeholderGroup.${scope.row.org_relationship}`) }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <IntroductoryList
      v-if="leader"
      :leader="leader"
      :loading="loading"
    />

    <CvcReport
      v-if="leader"
      :show.sync="showCvc"
      :engagement="leader.curr_engagement_uuid"
    />
  </div>
</template>

<script>
import api from '@/api';
import IntroductoryList from './widgets/IntroductoryList.vue';
import CvcReport from '../../common/cvc/CvcReport.vue';

export default {
  components: {
    IntroductoryList,
    CvcReport,
  },

  filters: {
    formatSession(value) {
      let text = 'Coach selection';
      if (value.includes('session_')) {
        text = value.replace('session_', '');
      }

      return text;
    },
  },

  data() {
    return {
      editMode: false,
      leader: null,
      teams: [],
      teamBackup: '',
      availabilityBackup: '',
      availabilityOptions: [
        {
          value: true,
          label: this.$t('oa.leader.active'),
        },
        {
          value: false,
          label: this.$t('oa.leader.inactive'),
        },
      ],
      showCvc: false,
      loading: false,
    };
  },

  computed: {
    lineManagers() {
      const team = this.teams.find((el) => el.uuid === this.leader.organization);
      const managers = team ? team.sponsor.join(', ') : 'None';
      return managers;
    },

    currentTeam() {
      const team = this.teams.find((el) => el.uuid === this.leader.organization.uuid);
      return team ? team.name : '';
    },

    responsiveCol() {
      const col = {};

      if (this.$mq === 'mobile') {
        col.one = 24;
        col.two = 24;
        col.big = 24;
        col.small = 24;
      } else if (this.$mq === 'tablet') {
        col.one = 16;
        col.two = 8;
        col.big = 12;
        col.small = 12;
      } else {
        col.one = 16;
        col.two = 8;
        col.big = 10;
        col.small = 4;
      }

      return col;
    },

    sortedStakeholders() {
      const roles = ['manager', 'peer', 'direct', 'other'];
      const sort = [];

      if (this.leader && this.leader.stakeholders && this.leader.stakeholders.length) {
        roles.forEach((role) => {
          this.leader.stakeholders.forEach((el) => {
            if (el.org_relationship.toLowerCase().includes(role)) {
              sort.push(el);
            }
          });
        });
      }

      return sort;
    },
  },

  async created() {
    await this.getLeader();
    await this.getTeamsList();
  },

  methods: {
    loadingHandler(key) {
      this.loading = key;
    },

    async getLeader() {
      try {
        this.loadingHandler(true);
        const response = await api.getLeaderDetails(this.$route.params.id);
        this.leader = response.data;
        this.teamBackup = response.data.organization.uuid;
        this.availabilityBackup = response.data.is_active;
        this.loadingHandler(false);
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    async getTeamsList() {
      try {
        const response = await api.getSimpleTeams();
        this.teams = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    async updateTeam() {
      const leader = this.leader.name ? this.leader.name : this.leader.email;
      const team = this.teams.find((el) => el.uuid === this.leader.organization.uuid);

      this.$confirm(this.$t('oa.leader.confirmUpdateTeam', { team: team.name, leader }), '', {
        confirmButtonText: this.$t('common.save'),
        cancelButtonText: this.$t('common.cancel'),
        roundButton: true,
        customClass: 'leaderConfirmation',
      }).then(async () => {
        try {
          this.loadingHandler(true);
          const response = await api
            .changeLeaderTeam(this.leader.uuid, this.leader.organization.uuid);
          this.leader.organization = response.data.organization;
          this.$message({
            message: this.$t('oa.leader.teamUpdated'),
            type: 'success',
          });
          this.teamBackup = this.leader.organization.uuid;
          this.loadingHandler(false);
        } catch (err) {
          if (err.msg) {
            this.$message.error(err.msg);
          }
          this.loadingHandler(false);
        }
      }).catch(() => {
        this.leader.organization.uuid = this.teamBackup;
      });
    },

    async updateAvailability() {
      const leader = this.leader.name ? this.leader.name : this.leader.email;
      const action = this.leader.is_active ? 'activate' : 'deactivate';

      this.$confirm(this.$t('oa.leader.confirmUpdateStatus', { action, leader }), '', {
        confirmButtonText: this.$t('common.save'),
        cancelButtonText: this.$t('common.close'),
        roundButton: true,
        customClass: 'leaderConfirmation',
      }).then(async () => {
        try {
          this.loadingHandler(true);
          const response = await api.changeLeaderAvailability(this.leader.uuid);
          this.leader.is_active = response.data.is_active;
          this.$message({
            message: this.$t('oa.leader.statusUpdated'),
            type: 'success',
          });
          this.availabilityBackup = this.leader.is_active;
          this.loadingHandler(false);
        } catch (err) {
          if (err.msg) {
            this.$message.error(err.msg);
          }
          this.loadingHandler(false);
        }
      }).catch(() => {
        this.leader.is_active = this.availabilityBackup;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #leaderDetails {
    .label {
      font-size: 13px;
      padding-bottom: 5px;
    }

    .data,
    .noData {
      & > div {
        margin-bottom: 18px;
      }
    }

    .actions.mainCard {
      text-align: center;
    }

    .leaderCard {
      .row1 {
        .left {
          display: inline-block;
          width: calc(100% - 80px);
          vertical-align: middle;

          .name {
            width: 100%;
            font-weight: bold;
            word-break: break-word;
          }

          .email {
            width: 100%;
            font-style: italic;
            word-break: break-word;

            .emailLink {
              color: var(--themeFontColor);

              &:not(:hover) {
                text-decoration: none;
              }
            }
          }
        }

        .clearBtn {
          vertical-align: middle;
          display: inline-block;
          width: 80px;
          background-color: transparent;
          color: var(--themeFontColor);
          padding: 13px 15px;
        }

        .saveBtn {
          vertical-align: middle;
          display: inline-block;
          width: 80px;
          padding: 13px 15px;
        }
      }

      .row2 {
        flex-wrap: wrap;

        .el-col {
          margin-top: 30px;
        }

        .reportBtn {
          vertical-align: middle;
          display: inline-block;
          width: 100%;
          background-color: transparent;
          color: var(--themeFontColor);
          padding: 13px 0;
          max-width: 160px;
        }
      }
    }
  }
</style>

<style lang="scss">
  #leaderDetails {
    .leaderCard {
      .el-card__body {
        text-align: left;
      }

      .el-select {
        .el-input {
          .el-input__inner {
            background-color: transparent;
            color: var(--themeFontColor);
            border-radius: 0;
            border-top-width: 0;
            border-right-width: 0;
            border-left-width: 0;
            padding-left: 0;
            font-size: 16px;
          }
        }
      }

      .el-radio-group {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 45px;

        .el-radio__inner {
          background-color: transparent;

          &:hover {
            border-color: var(--themeFontColor);
          }
        }

        .el-radio.is-checked {
          .el-radio__label {
            color: var(--themeFontColor);
          }

          .el-radio__inner {
            border-color: var(--themeFontColor);

            &:after {
              background-color: var(--themeFontColor);
            }
          }
        }
      }

      .lga {
        .lgaItem {
          display: flex;

          .lgaNumber {
            width: 18px;
          }
        }
      }
    }

    .supporterList {
      .el-table__empty-text {
        width: 100%;
        text-align: center;
        font-style: italic;
        padding: 70px 10px;
        line-height: 25px;
      }

      .el-table__header {
        tr {
          th:first-child {
            padding-left: 10px;
          }

          th:nth-child(2) {
            padding-left: 20px;
          }

          th:nth-child(3) {
            padding-left: 40px;
          }
        }
      }

      .el-table__row {
        td:first-child {
          padding-left: 10px;
        }

        td:nth-child(2) {
          padding-left: 20px;
        }

        td:nth-child(3) {
          padding-left: 40px;
        }

        .emailLink {
          color: var(--themeFontColor);

          &:not(:hover) {
            text-decoration: none;
          }
        }
      }
    }
  }

  .leaderConfirmation {
    // Necessary scss property
    $mobile: 499px;
    $tablet: 899px;

    .el-message-box__header {
      display: none;
    }

    .el-message-box__content {
      padding: 10px 25px 40px;
      margin-top: 5px;

      @media (max-width: $mobile) {
        padding: 10px 25px;
      }
    }

    .el-message-box__btns {
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-bottom: 10px;

      .el-message-box__content {
        padding: 25px 25px;
      }

      .el-button {
        width: 47% !important;

        @media (max-width: $tablet) {
          width: 100% !important;
        }
      }
    }
  }
</style>
